import type { GameState } from './state';

/** The single live game state. Logic modules read it through `S()`. */
let current: GameState | null = null;

export function S(): GameState {
  if (!current) throw new Error('Game state not initialised');
  return current;
}

export function hasGame(): boolean {
  return current !== null;
}

export function setGame(state: GameState): void {
  current = state;
}
